import moment from 'moment'
import enums from '@/enums'
import lodash from 'lodash'
import { formatPrice } from "@/helpers";

moment.locale("zh-CN")

const filterOption = (value, options) => options.filter(op => op.value == value)[0]

let tableHelper = {

  tag(value, options, defaultType = '') {
    return (filterOption(value, options) || { type: defaultType }).type
  },

  label(value, options, defaultLabel = '') {
    defaultLabel = defaultLabel || value
    return (filterOption(value, options) || { label: defaultLabel }).label
  },

  fmts: {

    price(_, __, value) {
      return formatPrice(value)
    },

    date(_, __, value) {
      return moment(value).calendar()
    },
    enums: {}
  }

}

lodash.forEach(enums, (enumObj, enumName) => {
  tableHelper.fmts.enums[enumName] = (_, __, value) => {
    return enumObj.label(value)
  }
})

export default {

  install(Vue) {
    Vue.prototype.$tableHelper = tableHelper
  }

}
